import { WasmHandler } from "react-lib/frameworks/WasmController";

import CONFIG from "config/config";
import { GoogleAuthProvider, onAuthStateChanged, signInWithCustomToken, signOut } from "firebase/auth";
import { httpsCallable } from "firebase/functions";

export type State = {
  firebaseToken?: string;
};

export const StateInitial = {
  firebaseToken: "",
};

export type Event =
  | { message: "FirebaseSetupStateChangeHandler"; params: {} }
  | { message: "FirebaseCustomLoginWithUsername"; params: {} }
  | { message: "FirebaseLogout"; params: {} };

type Handler = WasmHandler<State, Event>;

export const SetupStateChangeHandler: Handler = (controller, params) => {
  const onFirebaseAuthStateChanged = (user: any) => {
    if (user) {
      // Check if logged in
      console.log("user: ", user.email);
      console.log(params);
      params?.loginCallback?.(user, controller);
    } else {
      console.log("no user");
    }
  };
  if (controller.auth) {
    onAuthStateChanged(controller.auth, onFirebaseAuthStateChanged);
  }
  OpenLoginForm(controller);
};

export const CustomLoginWithUsername: Handler = async (controller, params) => {
  console.log("CustomLoginWithUsername: signInWithCustomToken");
  if (CONFIG.OFFLINE) return;

  try {
    if (controller.functions && controller.auth) {
      const createTokenFromUser = httpsCallable<string, string>(
        controller.functions,
        "createTokenFromUser"
      );

      const { data: customToken } = await createTokenFromUser(String(params.username));

      controller.setState({ firebaseToken: customToken });

      await signInWithCustomToken(controller.auth, customToken);
    }
  } catch (err) {
    console.error("Custom login failed:", err);
  }
};

export const Logout: Handler = (controller, params) => {
  if (controller.auth) {
    return signOut(controller.auth)
      .then(() => {
        params?.logoutCallback?.(controller);
        OpenLoginForm(controller, {}); // e.g. calls ui.start(...)
      })
      .catch((err) => {
        console.error("signOut failed:", err);
      });
  }
};

const OpenLoginForm: Handler = (controller, params) => {
  if (!controller.auth?.currentUser) {
    controller.ui?.start("#firebase-login", {
      callbacks: {
        signInSuccessWithAuthResult: function (authResult, redirectUrl) {
          return false; // avoid automatic redirect
        },
      },
      signInOptions: [GoogleAuthProvider.PROVIDER_ID], // ✅ modular constant
    });
  }
};
